import AccountAffiliationSection from '../sections/AccountAffiliationSection';

function AccountAffiliationView() {
  return (
    <div className="row g-4 justify-content-center">
      <div className="col-xl-12 col-lg-12">
        <div className="d-grid gap-4">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h2 className="h4 mb-1">Affiliation</h2>
              <p className="text-muted mb-0">
                Manage your organizations, clubs, communities, primary affiliations, and approver/admin selections.
              </p>
            </div>
          </div>
          <AccountAffiliationSection />
        </div>
      </div>
    </div>
  );
}

export default AccountAffiliationView;
